import { Card } from "antd";
import Image1 from "../../../../assets/images/measurementImage1.png";
import "../style.scss";
import { Col, Row } from "react-bootstrap";
import colourdata from "./colorCode.json";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useEffect, useState } from "react";

const initialData = [
  { name: "100", threshold: 2, light: 4, amt: 2 },
  { name: "200", threshold: 2, light: 4, amt: 2 },
  { name: "300", threshold: 2, light: 4, amt: 2 },
  { name: "400", threshold: 2, light: 4, amt: 2 },
  { name: "500", threshold: 2, light: 4, amt: 2 },
  { name: "600", threshold: 2, light: 4, amt: 2 },
  { name: "700", threshold: 2, light: 4, amt: 2 },
  { name: "800", threshold: 2, light: 4, amt: 2 },
  { name: "900", threshold: 2, light: 4, amt: 2 },
  { name: "1000", threshold: 2, light: 4, amt: 2 },
  { name: "1100", threshold: 2, light: 3.5, amt: 2 },
  { name: "1200", threshold: 2, light: 1, amt: 2 },
];

const GraphView = () => {
  const [data, setData] = useState(initialData);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setData((prevData) => {
        // Generate a new array with stable data and modified last two points
        const updatedData = [...prevData.slice(0, -2), 
          {
            ...prevData[prevData.length - 3],
            light: Math.random() < 0.5 ? 1 : 2,
          },
          {
            ...prevData[prevData.length - 2],
            light: Math.random() < 0.5 ? 0.7 : 2,
          },
          {
            ...prevData[prevData.length - 1],
            light: Math.random() < 0.5 ? 1 : 0.7,
          }
        ];
        return updatedData;
      });
    }, 1500);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <Card className="graph-view-container h-100">
      <div className="card-heading mb-3">
        Detailed Graph View Representation Warning
      </div>
      <div className="mb-4 w-100">
        <div style={{ width: "100%", height: 400 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" padding={{ left: 30, right: 30 }} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="light"
                stroke="#8884d8"
                activeDot={{ r: 8 }}
              />
              <Line type="monotone" dataKey="threshold" stroke="#82ca9d" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div>
        <Row>
          <Col md={12}>
            <div className="card-heading mb-2">Graph Description</div>
            <div className="card-text1">
              The speed log is an important source of data when calculating
              performance. Sensor accuracy depends on calibration and
              manufacturer. An offset between the speed log reading and the
              actual speed indicates a need for calibration.
            </div>
          </Col>
          {/* <Col md={6}>
            <div className="card-heading mb-2">Colour Codes & Results</div> */}
            {/* <Row>
              {colourdata.map((item: any) => (
                <Col md={6} className="d-flex gap-1 align-items-center mb-2">
                  <div
                    style={{ backgroundColor: item?.colour }}
                    className="color-code-view"
                  ></div>
                  <div className="card-text3">Color Codes & Results</div>
                </Col>
              ))} */}

              {/* <Col md={6} className="d-flex gap-2 align-items-center">
                <div className="color-code-view"></div>
                <div>Color Codes & Results</div>
              </Col> */}
            {/* </Row> */}
          {/* </Col> */}
        </Row>
      </div>
    </Card>
  );
};

export default GraphView;
